import { DynamischeStundenbewertung } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Abwesenheiten/DynamischeStundenbewertung';
import { Guttage } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Abwesenheiten/Guttage';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Separator,
} from '@e2n/ui';
import {
  faPenToSquare,
  faUmbrellaBeach,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line max-lines-per-function
export function Abwesenheiten() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  const feiertagValues: string[] = [];

  if (data.abwesenheiten.feiertagseinstellungen.zuschlagsregelungGreift) {
    feiertagValues.push(
      t(
        'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.options.zuschlagsregelungGreift',
      ),
    );
  }
  if (data.abwesenheiten.feiertagseinstellungen.stundenGutschreibung) {
    feiertagValues.push(
      t(
        'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.options.stundenGutschreibung',
      ),
    );
  }
  if (
    data.abwesenheiten.feiertagseinstellungen.taeglicheArbeitszeitAuffuellen
  ) {
    feiertagValues.push(
      t(
        'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.options.taeglicheArbeitszeitAuffuellen',
      ),
    );
  }

  return (
    <AccordionItem value="abwesenheiten">
      <AccordionTrigger className="flex gap-1">
        <FontAwesomeIcon icon={faUmbrellaBeach} />
        <span className="text-neutrals-900 text-xl font-bold leading-7">
          {t('domain.mitarbeiter.create.steps.abwesenheiten.title')}
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="py-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.label',
              )}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() => ctx.navigateToSubStep('abwesenheiten.allgemein')}>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>
          <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
            <span>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.zusammenfassung.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.zusammenfassung.text',
                {
                  anzahl: data.abwesenheiten.allgemein.anzahlUrlaubstage,
                },
              )}
            </span>
            <span>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.zusammenfassung.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.options.' +
                  data.abwesenheiten.allgemein.anzahlArbeitstage,
              )}
            </span>
            <span>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.zusammenfassung.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.zusammenfassung.options.' +
                  data.abwesenheiten.allgemein.stundenBewertung,
              )}
            </span>
            {data.abwesenheiten.allgemein.stundenBewertung === 'fest' ? (
              <>
                <span>
                  {t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.label',
                  )}
                </span>
                <span className="text-neutrals-900 font-semibold">
                  {`${data.abwesenheiten.allgemein.stunden} ${t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.suffix',
                  )}`}
                </span>
              </>
            ) : (
              <DynamischeStundenbewertung />
            )}
          </div>
        </div>
        <Guttage />
        <Separator />
        <div className="py-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.label',
              )}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() =>
                ctx.navigateToSubStep('abwesenheiten.feiertagseinstellungen')
              }>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>
          <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
            <span>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {feiertagValues.length > 0 ? feiertagValues.join(', ') : '-'}
            </span>
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
